export default __webpack_public_path__ + "static/media/Kannada_book_f.348eda00.wav";